import React from 'react';
import Reveal from './Reveal';
import AppStoreLink from './AppStoreLink';

/** Closing CTA (handoff §8) - free-scan count corrected to the real quota. */
const CTA = () => (
  <section id="download" className="section" aria-labelledby="cta-headline">
    <div className="section-inner">
      <Reveal>
        <div className="card closing-cta-card">
          <h2 id="cta-headline" className="h2">
            Tonight's dinner is already on your camera roll.
          </h2>
          <p className="lead">
            Free on the App Store. Seven AI actions a month with a free account, no card, nothing to
            cancel.
          </p>
          <div className="closing-cta-actions">
            <AppStoreLink />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTA;
